import React from "react";

const EventSkeletons = () => (
    <>
        <div className="event-skeleton" />
        <div className="event-skeleton" />
        <div className="event-skeleton" />
        <div className="event-skeleton" />
        <div className="event-skeleton" />
        <div className="event-skeleton" />
        <div className="event-skeleton" />
        <div className="event-skeleton" />
        <div className="event-skeleton" />
    </>
);

export default EventSkeletons;
